import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import AutoZoneDetectionsTable from '../components/AutoZoneDetectionsTable';
import AutoZoneDetectionsModel from '../components/AutoZoneDetectionsModel';

import ParkinglocationSelect from '../components/ParkinglocationSelect';

import { Layout, Button, Row, Col, Input, Icon, message, DatePicker } from 'antd';

class AutoZoneDetectionsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    parkinglocation: null,
    dateFrom: moment().startOf('day'),
    dateTo: moment().endOf('day')
  }

  componentWillMount() {
    this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
  }

  loadData(parkinglocation = null, dateFrom = null, dateTo = null) {
    dateFrom = dateFrom ? dateFrom.format() : null;
    dateTo = dateTo ? dateTo.format() : null;
    this.setState({
      dataLoading: true,
      dataAll: [],
      data: []
    });
    AutoZoneDetectionsModel.getAll(
      parkinglocation,
      dateFrom,
      dateTo
    )
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(err => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(this.state.parkinglocation, dates[0], dates[1]);
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Park-Detect - Detekované zóny</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={16}>
                <ParkinglocationSelect onChange={(value) => {
                  this.setState({ parkinglocation: value });
                  this.loadData(value, this.state.dateFrom, this.state.dateTo);
                }}
                  style={{ width: 300 }} />
                {' '}
                <DatePicker.RangePicker
                  defaultValue={[
                    this.state.dateFrom,
                    this.state.dateTo
                  ]}
                  ranges={{
                    "Dnes": [moment().startOf('day'), moment().endOf('day')],
                    "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                    "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                  }}
                  allowClear={false}
                  placeholder={['Od', 'Do']}
                  format="DD.MM.YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  onOk={this.onDateRangeChanged.bind(this)}
                  style={{ width: 300 }}
                />
              </Col>
              <Col span={8} offset={0} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => {
                  this.loadData(this.state.parkinglocation, this.state.dateFrom, this.state.dateTo);
                }}><Icon type="sync" /></Button>
              </Col>
            </Row>
          </div>
          <AutoZoneDetectionsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRemoveRow={(id) => {
              AutoZoneDetectionsModel.remove(id)
                .then(() => {
                  this.loadData(true);
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default AutoZoneDetectionsScreen;



// WEBPACK FOOTER //
// ./src/screens/AutoZoneDetectionsScreen.js